/* eslint-disable prettier/prettier */
import React from 'react';

export const playerStatsOptions = [
  {
    key: 'distance',
    name: 'Löpdistans (m)',
  },
  {
    key: 'maxSpeed',
    name: 'Maxhastighet (km/h)',
  },
];

function MatchPlayerStatsFilter({
  playersStats,
  selectedStat,
  setSelectedStat,
  team,
  setTeam,
  setPlayerLimit,
}) {
  const playerPositions = new Set().add('Alla positioner');
  const playerTeams = [];
  playersStats?.forEach((player) => {
    if (player.position) {
      playerPositions.add(player.position);
    }
    if (player.teamAbbrv) {
      if (!playerTeams.find((t) => t.teamAbbrv === player.teamAbbrv)) {
        playerTeams.push({
          teamAbbrv: player.teamAbbrv,
          teamDisplayName: player.teamDisplayName,
        });
      }
    }
  });

  playerTeams.sort((a, b) => {
    a.teamDisplayName.toUpperCase();
    b.teamDisplayName.toUpperCase();
    return a.teamDisplayName.localeCompare(b.teamDisplayName);
  });

  playerTeams.unshift({
    teamAbbrv: '',
    teamDisplayName: 'Båda lagen',
  });

  return (
    <div className="data-container__header">
      <div className="row px-4 pt-3 pb-2">
        <div className="d-block d-md-none col-12 col-md pe-md-1 mb-3 mb-md-0">
          <p className="heading-h6 mb-1">Sorterat på</p>
          <select
            value={selectedStat}
            onChange={(e) => {
              setSelectedStat(e.target.value);
              setPlayerLimit(20);
            }}
            className="select"
          >
            {playerStatsOptions?.map((option) => (
              <option value={option?.key}>{option?.name}</option>
            ))}
          </select>
        </div>
        <div className="col-12 col-md pe-md-1 mb-3 mb-md-0">
          <p className="heading-h6 mb-1">Lag</p>
          <select
            value={team}
            onChange={(e) => {
              setTeam(e.target.value);
              setPlayerLimit(20);
            }}
            className="select"
          >
            {playerTeams?.map((t) => (
              <option value={t.teamAbbrv}>{t.teamDisplayName}</option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
}

export default MatchPlayerStatsFilter;
